import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError, map, Observable, of, throwError } from 'rxjs';

import { ServiceResponseV1 } from '@core/models/apis';
import { UserProfileV1 } from '@core/models/users';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private readonly http = inject(HttpClient);
  private readonly usersApiUrl = `${environment.apiUrl}${environment.apis.usersEngineAdmin}/v1/users`;

  private handleResourceError(err: unknown): Observable<never> {
    const error =
      err instanceof HttpErrorResponse
        ? new Error(`HTTP ${err.status}: ${err.message}`)
        : err instanceof Error
          ? err
          : new Error(String(err));
    return throwError(() => error);
  }

  createUserProfileResource(userId: () => string | null) {
    return rxResource<UserProfileV1 | null, string | null>({
      params: () => userId(),
      stream: ({ params }) => {
        if (!params) return of(null);
        return this.http
          .get<ServiceResponseV1<UserProfileV1>>(`${this.usersApiUrl}/${params}/profiles`)
          .pipe(
            map((response) => response.data ?? null),
            catchError((err) => {
              if (err instanceof HttpErrorResponse && err.status === 404) {
                return of(null);
              }
              return this.handleResourceError(err);
            })
          );
      }
    });
  }

  getUserProfileByUserId(userId: string): Observable<UserProfileV1 | null> {
    return this.http.get<ServiceResponseV1<UserProfileV1>>(`${this.usersApiUrl}/${userId}/profiles`).pipe(
      map((response) => response.data ?? null),
      catchError((err) => {
        if (err instanceof HttpErrorResponse && err.status === 404) {
          return of(null);
        }
        return this.handleResourceError(err);
      })
    );
  }
}
